import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SePlatformModule, SeSharedModule } from '@se/platform';
import { SeComponentsModule } from '@se/components';
import { routes } from './toolupload.routes';
import { TooluploadFormComponent } from './toolupload/toolupload-form/toolupload-form.component';
import { TooluploadToolbarComponent } from './toolupload/toolupload-toolbar/toolupload-toolbar.component';
import { TooluploadService } from './toolupload.service';
// added modules
import { ClipboardModule } from '@angular/cdk/clipboard';
import { DatePipe } from '@angular/common';
import { FileUploadComponent } from './toolupload/uploadcomponent/file-upload.component';
import { ErrorStateMatcher } from '@angular/material/core';
import { VnaErrorMatcher } from './utils/vna-error-matcher';
import { ImportFileComponent } from './toolupload/import-file/import-file.component';
import { FileComponent } from './toolupload/file/file.component';
import { HelperService } from './utils/helper.service';
import { TooluploadDialogComponent } from './toolupload/dialog/toolupload-dialog.component';
import { DicomLandingPage } from './toolupload/dicom/pages/landing-page/landing-page.component';
import { PatientDetailsFormComponent } from './toolupload/dicom/components/patient-details-form/patient-details-form.component';
import { StudyComponent } from './toolupload/dicom/components/study/study.component';
import { SeriesComponent } from './toolupload/dicom/components/series/series.component';
import { FeedbackComponent } from './toolupload/dicom/components/feedback/feedback.component';
import { MessageDialogComponent } from './toolupload/dicom/components/message-dialog/message-dialog.component';

@NgModule({
    declarations: [],
    imports: [
        TooluploadToolbarComponent,
        FileUploadComponent,
        MessageDialogComponent,
        TooluploadFormComponent,
        ImportFileComponent,
        FileComponent,
        TooluploadDialogComponent,
        FeedbackComponent,
        PatientDetailsFormComponent,
        DicomLandingPage,
        StudyComponent,
        SeriesComponent,
        SePlatformModule,
        SeComponentsModule,
        SeSharedModule,
        RouterModule.forChild(routes),
        ClipboardModule,
    ],
    exports: [
        TooluploadFormComponent,
        FileUploadComponent,
        ImportFileComponent,
        FileComponent,
        TooluploadDialogComponent,
        MessageDialogComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        TooluploadService,
        HelperService,
        DatePipe,
        {
            provide: ErrorStateMatcher,
            useClass: VnaErrorMatcher,
        },
    ],
    bootstrap: [],
})
export class TooluploadModule {}
